import CollectionContainer from '../sections/collection-container';

document.addEventListener('DOMContentLoaded', () => {
  new CollectionContainer();
});
